import BreakfastCerealProduct from 'models/BreakfastCerealProduct'

export const packagingInitialState = {
  category: BreakfastCerealProduct.category,
  subCategory: BreakfastCerealProduct.subCategory,
  Kcals: BreakfastCerealProduct.Kcals,
  Folate: BreakfastCerealProduct.Folate,
  Fiber: BreakfastCerealProduct.Fiber,
  WholeGrainCert: BreakfastCerealProduct.WholeGrainCert,
  Iron: BreakfastCerealProduct.Iron,
  Sucrose: BreakfastCerealProduct.Sucrose,
  Rounding: BreakfastCerealProduct.Rounding,
  UnderIronLimit: BreakfastCerealProduct.Iron,
  UnderSucroseLimit: BreakfastCerealProduct.UnderSucroseLimit,
  ContainsNoSweeteners: BreakfastCerealProduct.ContainsnsNoSweeteners,
  Size: BreakfastCerealProduct.Size,
}